/**
 * Picture enamelling — the customer-facing copy, in one place.
 *
 * A colour photograph printed onto the piece and sealed under a clear lacquer. Offered
 * per-product (Admin ▸ Product ▸ Features ▸ Picture Enamelling) and charged as a flat
 * workshop add-on on top of the finished price, exactly like the chain.
 *
 * ⚠️ WHERE THE MONEY COMES FROM. Every £ the customer is shown or charged comes off the
 * SERVER — `productIdData.pictureEnamelling.gbp` on the product page, and
 * backend/utils/enamelPricing.js again at checkout, which is the single source of truth.
 * PICTURE_ENAMELLING_GBP below is a LABEL ONLY, for the admin toggle's hint, where there is
 * no product payload to read (the block is null until the switch is on — which is precisely
 * when the number needs printing). If the price ever changes, change it in
 * backend/utils/enamelPricing.js FIRST and mirror it here; nothing a customer pays depends
 * on this constant, but an admin reading a stale hint would still be misled.
 */
export const PICTURE_ENAMELLING_GBP = 25;

/** Panel heading + the one-line prompt beside the toggle on the product page. */
export const PICTURE_ENAMELLING_LABEL = "Picture Enamelling";

/**
 * What the (i) modal says.
 *
 * The lead is what the customer gets; the water limit is a point-of-sale disclosure and
 * stays explicit rather than being softened away — someone who wears a locket in the shower
 * has to have been told here, not after.
 */
export const PICTURE_ENAMELLING_INTRO =
  "Your photograph, reproduced in full colour on the face of the piece and sealed under a " +
  "clear lacquer — a keepsake you can wear every day.";

export const PICTURE_ENAMELLING_POINTS = [
  {
    title: "How it is made",
    body:
      "We print your picture in colour directly onto the pendant, then seal it under a clear " +
      "protective lacquer that gives it depth and a soft shine.",
  },
  {
    title: "Everyday wear",
    body:
      "The lacquer is splash-proof, so rain, a hand-wash and everyday life are no trouble at all.",
  },
  {
    title: "Please keep it out of water",
    body:
      "It is not waterproof and must not be submerged — take the piece off before swimming, " +
      "bathing or showering, and avoid steam rooms and ultrasonic cleaners.",
  },
];
